import {FC} from 'react';
import {chakra} from '@chakra-ui/react';
import {Svg} from 'ui-kit';

interface IProps {
  icon: 'ArrowThinLeft';
  isNext?: boolean;
  onClick: () => void;
}

export const NavButton: FC<IProps> = ({icon, isNext, onClick}) => (
  <chakra.button
    type={'button'}
    display={'flex'}
    alignItems={'center'}
    justifyContent={'center'}
    w={'28px'}
    h={'28px'}
    color={'{colors.textPrimary}'}
    borderRadius={'6px'}
    cursor={'pointer'}
    transform={isNext ? 'rotate(180deg)' : undefined}
    _hover={{background: '{colors.bgSurface}'}}
    onClick={onClick}
  >
    <Svg name={icon} size={'s20'} />
  </chakra.button>
);
